<template>
  <div>
    <b-card no-body header="今年運勢分析" class="mb-2" border-variant="primary" header-bg-variant="primary" header-text-variant="white">
      <b-card-body >

        <div v-for="(item , index) in listdata" v-bind:key="index" class="text-center p-0 my-1 float-left" style="width: 100%">


          <b-row>
            <b-col cols="4" align-self="start">
              <div  class="primaryGColor text-white rounded p-2 shadow">
              <p class="small">{{ item.year}}</p>
              <h3>{{ item.yeardata.result}}</h3>
            </div>
            </b-col>
            <b-col align-self="start" style="text-align: left">

              <b-list-group flush v-if="index==0 " >
                <b-list-group-item  >{{ explantion(item) }}</b-list-group-item>
              </b-list-group>


              <b-list-group flush v-if="index>=1 && hasexplantion(item)" >
                <b-list-group-item  >{{ explantion(item) }}</b-list-group-item>
              </b-list-group>
                <b-list-group flush v-if="index>=1 && !hasexplantion(item)" style="color: transparent;text-shadow:2px 2px 12px #000000;">
                  <b-list-group-item >{{randtexts() }}</b-list-group-item>
                </b-list-group>


              <b-button v-if="index>=1 && !hasexplantion(item) " class="mt-1" pill variant="outline-primary" size="lg" @click="callaction">  <b-icon icon="lock-fill"></b-icon>解鎖整體流年</b-button>




            </b-col>
          </b-row>

        </div>

      </b-card-body>

    </b-card>





  </div>
</template>
<style>
  .YearCard{
    height: 50vh;
    max-height: 500px;
  }
  .yearCircle{
    height: 50vw;
    max-height: 300px;
    max-width: 300px;
    width: 50vw;
    /*background-color: #be9167;*/
    border-color: #be9167 !important;
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 50rem;
  }
</style>

<script>
import {mapState} from 'vuex'
export default {
  name: 'AllYearResultCard',
  components: {},
  props: {
    Vipstatus:Boolean,
    listdata: Array,
    allyear: Array,

  },

  computed:{
    ...mapState(['profiledata']),
    name:function () {return this.profiledata !==null ? this.profiledata.first_name+this.profiledata.last_name : '';},
  },

  data () {
    return {
      randNum:0,
      randText:[
        {result:'不是吧棯虮扠燔艅廥彴一軴啍瓵杸刉厙丌，嗍嵑乇妵牁葌徂氶屮芫蓒峉尐怐，气疺呤娸狪岢佸抎裚屮玬慲溗。'},
        {result:'愅呫犴橏裬尻洢亍，遄偨兀岣秏腩佮圢屮皯睾柟圠岠。胾呴邗諟嵊嬖汌一袲堈袟杺尒恟丌，鉖棪屮岯丌岰禒姴气泒。'},
        {result:'棯虮扠燔艅瓵杸刉厙丌，气疺呤娸狪鸁葯歈屻夼挌芓岢佸抎裚屮玬慲溗。'},
        {result:'愅呫犴橏裬踶朼枘尻洢亍，遄偨兀岣秏腩佮圢屮皯睾柟圠岠。胾呴邗諟嵊嬖汌一袲堈袟杺尒恟丌。'},
        {result:'捑一胅唲罦銃亍誋擳勼，脙亍拏桭堭搊亍嘝殳氻。祫一斪剬跖鳧乇墿仂，偳楘乜僣冘仜。'}
      ],
      flickityOptions: {
        initialIndex:0,
        pauseAutoPlayOnHover: true,
        prevNextButtons: true,
        pageDots: false,
        contain: false,
        watchCSS: false,
        wrapAround: true,
        lazyLoad: true
      },
      containList:[],
      selectIndex:0,

    }
  },
  mounted() {

  },
  methods: {
    callaction () {

      this.$emit('sendAction');
    },
    hasexplantion(data){
      if(data.yeardata.hasOwnProperty('explantion')){
        return true
      }else{
        return false
      }

    },
    explantion(data){


      if(data.yeardata.hasOwnProperty('explantion')){
        return data.yeardata.explantion[0].result
      }


    },
    randtexts(){
      return this.randText[0].result
    }
  }
}
</script>
